
//数据 state
const state = {
  state: false,
  select: -1,
  cameras: []
}

//获取数据 getters
const getters = {
  lensEditState  : state => state.state,
  lensIndex  : state => state.select,
  cameras  : state => state.cameras,
}

//修改数据 mutations
const mutations = {
  toggle_lensEditState (state, data){
    // selectScenesMsg
    state.state = data ? data  : false;
  },
  toggle_lensIndex (state, data){
    // selectScenesMsg
    state.select = data + 1 ? data  : -1;
  },
  toggle_cameras (state, data){
    // selectScenesMsg
    state.cameras = data ? data  : [];
  },
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/camera.js